import React, { useEffect, useState } from 'react';

import type { CoverPictureId } from '@confluence/page-cover-picture/entry-points/pageCoverPictureTypes.ts';
import { RendererPageCoverPicture } from '@confluence/page-cover-picture/entry-points/RendererPageCoverPicture.ts';
import { propertyToId } from '@confluence/page-cover-picture/entry-points/coverPictureHelperFunctions.ts';
import { ContentAppearanceType } from '@confluence/content-appearance/entry-points/contentAppearanceTypes.ts';

import { HeaderImageContainer, NoHeaderImageSpacer } from './presenterModeStyles.tsx';
// eslint-disable-next-line import/no-cycle
import { createHigherResImgSrc } from './utilities.ts';

type HeaderImgProps = {
	contentId: string;
	coverPictureProperty: any;
};

type CoverPictureData = {
	draft: null;
	published: CoverPictureId | null;
};

export const HeaderImageContainerId = 'presenter-mode-header-image-container';

export const HeaderImage = ({
	contentId,
	coverPictureProperty,
}: HeaderImgProps): React.JSX.Element => {
	const [coverPictureData, setCoverPictureData] = useState<CoverPictureData | undefined>(undefined);

	useEffect(() => {
		if (!coverPictureProperty) {
			return;
		}

		const publishedId = propertyToId(coverPictureProperty);

		if (!publishedId) {
			return;
		}

		const coverPic = {
			draft: null,
			published: {
				value: {
					id: createHigherResImgSrc(publishedId?.value?.id),
					position: publishedId?.value?.position || 0,
				},
				version: publishedId?.version,
			},
		};

		setCoverPictureData(coverPic);
	}, [coverPictureProperty]);

	if (!coverPictureData) {
		return <NoHeaderImageSpacer />;
	}

	return (
		<HeaderImageContainer id={HeaderImageContainerId}>
			<RendererPageCoverPicture
				contentId={contentId}
				isPagePreview={false}
				coverPicture={coverPictureData}
				contentAppearance={{
					draft: '',
					published: ContentAppearanceType.FULL_WIDTH,
				}}
				isSpaceOverview={false}
				isPresenterMode
			/>
		</HeaderImageContainer>
	);
};
